<template>
  <div style="padding-right:25px;">
    <b-card>
      <b-form-group>
        <center>
          <h3 id="doc_caution_title">目次</h3>
        </center>
        <hr>
        <p class="doc_caution_content">この報告書はユーザの情報資産を含む機密情報です。</p>
        <p class="doc_caution_content">本報告書のご利用にあたり下記の禁止事項を参照ください。</p>
        <p class="doc_caution_content">1. 本報告書内の情報を漏洩しない</p>
        <p class="doc_caution_content">2. 許可なく転写、転載の禁止</p>
        <p class="doc_caution_content">3. セキュリティ管理者、またはそれに基づく関係者以外の閲覧を禁止</p>

      </b-form-group>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "caution",
  data: () => {
    return {};
  },
  created: function() {
    console.log("[F1-UWSS]Caution.vue", "created");
  },
  destroyed: function() {
    console.log("[F1-UWSS]Caution.vue", "destroyed");
  },
  mounted: function() {
    console.log("[F1-UWSS]Caution.vue", "mounted");
  }
};
</script>
